export function setLogos(login_logo, logo, nav_logo, server_email_name) {
    return function(dispatch) {
        dispatch({type: "SET_LOGOS", payload: {
            login_logo: login_logo,
            logo: logo,
            nav_logo: nav_logo,
            server_email_name: server_email_name,
        }})
    }
}